import config from './config';
export const fetchLogoProps = (idp) => {
  const logoProps = {};
  if (!idp) {
    logoProps.logoText = 'athenahealth';
    logoProps.logoUrl = config.logoUrl;
  }
  return logoProps;
};
